import { ReactNode } from "react"
import { useGoogleIsAuthenticated } from "hooks/google/useGoogleAuthenticated"
import { GoogleServicesPopup } from "@components/molecules/GoogleServicesPopup"
import { DefaultTemplate, DefaultTemplateProps } from "./default"
import { useGoogleConnect } from "hooks/google/useGoogleConnect"
import { LoadingComponent } from "@components/atoms/Loading"


export interface GoogleServicesTemplateProps extends DefaultTemplateProps {
    children: ReactNode
}

export const GoogleServicesTemplate = ({ children, ...rest }: GoogleServicesTemplateProps) => {
    const { data: googleAuth, isLoading, isPaused } = useGoogleIsAuthenticated()
    const [connectGoogleHandler, activated] = useGoogleConnect()
    const { subnavbar, actions, left, right, sideaction, ...r } = rest
    const deactivated = { subnavbar, actions, left, right, sideaction }
    // logger.debug(googleAuth)

    return <DefaultTemplate {...(googleAuth?.authenticated && deactivated)} {...r}>
        {!googleAuth.authenticated ?
            <div className="flex flex-col items-center justify-center h-full">
                {isPaused || isLoading ?
                    <LoadingComponent className={`transition-opacity duration-500 ${isLoading ? 'opacity-100' : 'opacity-0'}`} />
                    : <GoogleServicesPopup onClick={connectGoogleHandler} />
                }
            </div> : children}
    </DefaultTemplate>
}